import { Maybe } from 'maybeasy';
import { updateLearningCollection } from '.';
import LearningCollectionEditStore from '..';
import { SavingDetails } from '../Types';
import { checkTemplateAndReadyStoreForEdits } from './LoadForEdits';
import { FileMetaData } from '../../CurrentCollectionStep/Details/S3ImageUpload/Types';

const saveDetails = (
  store: LearningCollectionEditStore,
  state: SavingDetails,
  fileMetaData: Maybe<FileMetaData>,
) =>
  updateLearningCollection(store, state, fileMetaData)
    .andThen(checkTemplateAndReadyStoreForEdits(store))
    .fork(() => store.editingDetails(state.celebrationPage), store.building);

export default saveDetails;
